// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1CLH9","footer":"ChangeClinic_footer__2d0lp"};